<template>
  <div>
    <b-container>
        <b-row>
            <b-col sm="12" cols="12" >
                <b-card no-body border-variant="msstream" class="marginal">
                    <b-card-header header-bg-variant="msstream" header-text-variant="white" class="text-center">
                    <h5>{{video.title}} - UUID:{{video.uuid}}</h5>
                    </b-card-header>
                    <b-card-body>
                        <b-row>
                            <b-form-textarea
                            id="textarea"
                            v-model="videoJson"
                            placeholder=""
                            rows="0"
                            max-rows="25"
                            ></b-form-textarea>
                        </b-row>
                        <b-row class="justify-content-around" style="margin-top:15px;">
                            <b-button variant="green" @click="updateVideo()" ><i class="fas fa-check"></i> Update</b-button>
                        </b-row>
                    </b-card-body>
                </b-card>
            </b-col>
        </b-row>
    </b-container>

    <b-modal ref="confirmDelete" hide-footer hide-header>
      <div class="d-block text-center">
        <h3>Delete</h3>
      </div>
      <p>Are you sure you want to delete this user ?</p>
      <b-row class="justify-content-around">

          <b-btn class="col-md-3 col-5" variant="quanteec" block @click="removeUser(userSelected);hideModal('confirmDelete')">Yes, delete</b-btn>

          <b-btn class="col-md-3 col-5" variant="mswarning" block @click="hideModal('confirmDelete')">Cancel</b-btn>

      </b-row>
  </b-modal>

  <b-modal ref="UpdateOk" hide-footer hide-header>
      <div class="d-block text-center">
        <h3>Success</h3>
      </div>
      <p>Update success</p>
      <b-row class="justify-content-around">

          <b-btn class="col-md-3 col-5" variant="green" block @click="hideModal('UpdateOk')">Ok</b-btn>

      </b-row>
  </b-modal>
  <b-modal ref="UpdateError" hide-footer hide-header>
      <div class="d-block text-center">
        <h3>Error</h3>
      </div>
      <p>Update error. Please verify the syntax of the video</p>
      <b-row class="justify-content-around">

          <b-btn class="col-md-3 col-5" variant="quanteec" block @click="hideModal('UpdateError')">Ok</b-btn>

      </b-row>
  </b-modal>
  <b-modal ref="UpdateParseError" hide-footer hide-header>
      <div class="d-block text-center">
        <h3>Error</h3>
      </div>
      <p>Can not parse the JSON object.</p>
      <b-row class="justify-content-around">

          <b-btn class="col-md-3 col-5" variant="quanteec" block @click="hideModal('UpdateParseError')">Ok</b-btn>

      </b-row>
  </b-modal>
  </div>
</template>

<script>
import VideoService from '@/services/video.service';

import { EventBus } from '@/event-bus.js';

var videoService = new VideoService();

export default {
  name: 'VideoAdmin',
  data: function() {
      return {
          uuid: '',
          video: {},
          videoJson : ''
      }
  },
  mounted() {
      this.uuid = this.$route.params['uuid'];
      this.getVideo();
  },
  methods:{

    getVideo() {
        videoService.getVideoById(this.uuid, this.$auth.token()).then(video => {
            let js = JSON.stringify(video, null, 2);
            this.videoJson = js;
            this.video = video;
        }).catch(err => {

        })
    },
    updateVideo() {
        let finalVideo = {};
        try {
            finalVideo = JSON.parse(this.videoJson);
        } catch(err) {
            this.showModal('UpdateParseError')
            return;
        }
         
        videoService.putVideoAdmin(finalVideo, this.uuid, this.$auth.token()).then(video => {
            let js = JSON.stringify(video, null, 2);
            this.videoJson = js;
            this.video = video;
            this.showModal('UpdateOk')
        }).catch(err => {
            this.showModal('UpdateError')
        })
    },
    showModal(modal) {
      this.$refs[modal].show();
    },
    hideModal(modal) {
      this.$refs[modal].hide();
    },
  }
}
</script>
<style scoped lang="scss">



</style>